import { gql } from "@apollo/client";

export const GET_PAYMENT_REPORT = gql`
  query GetPaymentReport($query: QueryInput, $payment: PaymentReportInput) {
    report(query: $query, payment: $payment) {
      payments {
        id
        success
        payment_amount
        invoice_numbers
        ref_num
        applied_at
        payment_method
        customer {
          id
          business_name
          fullname
        }
        created_at
        updated_at
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;
